export default __webpack_public_path__ + "img/Plus.9ce3d040.svg";